'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.changePaginationPageSize = exports.changePaginationSortOrder = exports.CHANGE_PAGINATION_PAGE_SIZE = exports.CHANGE_PAGINATION_SORT_ORDER = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

exports.paginationLocalStorageReducer = paginationLocalStorageReducer;
exports.paginationCookiesReducer = paginationCookiesReducer;
exports.getPaginationSortOrder = getPaginationSortOrder;
exports.getPaginationPageSize = getPaginationPageSize;

var _reactCookie = require('react-cookie');

var _reactCookie2 = _interopRequireDefault(_reactCookie);

var _constants = require('redux-persist/constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var CHANGE_PAGINATION_SORT_ORDER = exports.CHANGE_PAGINATION_SORT_ORDER = 'la/ui/pagination/sortOrder';
var CHANGE_PAGINATION_PAGE_SIZE = exports.CHANGE_PAGINATION_PAGE_SIZE = 'la/ui/pagination/pageSize';

// reducer
var DEFAULT_LOCAL_STORAGE_STATE = {
    sort: {}
};
var DEFAULT_COOKIE_STATE = {
    pageSize: 24
};

function paginationLocalStorageReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_LOCAL_STORAGE_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case _constants.REHYDRATE:
            if (Object.prototype.hasOwnProperty.call(action.payload, 'persist') && Object.prototype.hasOwnProperty.call(action.payload.persist, 'pagination')) {
                var incoming = action.payload.persist.pagination;
                return (0, _extends4.default)({}, state, incoming);
            }
            return state;
        case CHANGE_PAGINATION_SORT_ORDER:
            return (0, _extends4.default)({}, state, {
                sort: (0, _extends4.default)({}, state.sort, (0, _defineProperty3.default)({}, action.payload.type, action.payload.sortOrder))
            });
        default:
            return state;
    }
}

function paginationCookiesReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_COOKIE_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case CHANGE_PAGINATION_PAGE_SIZE:
            return (0, _extends4.default)({}, state, {
                pageSize: action.payload
            });
        default:
            return state;
    }
}

/* SELECTORS */
// Because this is global it will not be able to return a default.
function getPaginationSortOrder(state, type) {
    return state.persist.pagination.sort[type] || '';
}

function getPaginationPageSize(state) {
    return state.ui.pagination.pageSize || 24;
}

/* ACTION CREATORS */
var changePaginationSortOrder = exports.changePaginationSortOrder = function changePaginationSortOrder(type, sortOrder) {
    return {
        payload: { sortOrder: sortOrder, type: type },
        type: CHANGE_PAGINATION_SORT_ORDER
    };
};

var changePaginationPageSize = exports.changePaginationPageSize = function changePaginationPageSize(pageSize) {
    var expires = new Date();
    expires.setDate(expires.getDate() + 60);
    _reactCookie2.default.save('pagination-page-size', pageSize, {
        domain: '.liveauctioneers.com',
        expires: expires,
        path: '/'
    });
    return {
        payload: pageSize !== 'all' ? Number(pageSize) : pageSize,
        type: CHANGE_PAGINATION_PAGE_SIZE
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/pagination.js
// module id = DNXl
// module chunks = 57